<template>
  <div class="content">
    <div class="bodycontent">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="180px"
      >
        <el-form-item label="分组名称" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="选择商家">
          <el-button type="text">选择</el-button>
        </el-form-item>
        <el-form-item label="商品免审核">
          <el-radio-group v-model="formData.is_exe">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设置商品佣金">
          <el-radio-group v-model="formData.is_charge">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="修改订单价格">
          <el-radio-group v-model="formData.is_order_ed">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单确认收货">
          <el-radio-group v-model="formData.is_order_confirm">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否默认分组">
          <el-radio-group v-model="formData.is_group">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio-group v-model="formData.is_status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="save">提交</el-button>
        <el-button type="info" class="ml30" @click="goback">返回列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AddGroup, EditGroup } from "@/api/merchant";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  data() {
    return {
      formData: {},
      if_add: true,
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }]
      }
    };
  },
  methods: {
    init() {
      this.formData = this.$route.query.editData || {
        token: this.token,
        app_id: this.app_id,
        name: "",
        is_exe: 1,
        is_charge: 1,
        is_order_ed: 1,
        is_order_confirm: 1,
        is_group: 1,
        is_status: 1
      };
      if (this.formData.id) {
        this.if_add = false;
      }
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      data.image_id = this.image_id;
      data.token = this.token;
      data.app_id = this.app_id;
      console.log(data);
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.if_add) {
            AddGroup(data).then(res => {
              console.log(res);
              if (res.code == "1") {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              }
            });
          } else {
            EditGroup(data).then(res => {
              console.log(res);
              if (res.code == "1") {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              }
            });
          }
        } else {
          this.$message({
            type:"warning",
            message:"表单信息不完整"
          })
          return false;
        }
      });
      
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    .input_box {
      width: 400px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
  }
}
</style>
